module.exports = __webpack_public_path__ + "static/audience-weddings-fcb9a21030c5960883aadbd6caa60524.jpg";